export { CollectionCategoriesMobile } from './CollectionCategoriesMobile';
